module.exports = __webpack_public_path__ + "img/blog-16.6c183148.jpg";